// ── Plan configuration (source of truth for pricing & feature gating) ─────────
export const PLAN_CONFIG = {
  essentiel: {
    name: "Essentiel",
    price: 29,
    tabs: ["itineraire", "roadmap", "carte", "infos", "vols"],
    chatbot: false,
    desc: "L'essentiel pour partir bien préparé",
    features: [
      "Itinéraire jour par jour, personnalisé",
      "Informations pratiques essentielles",
      "Checklist documents et visa",
      "Validation par Diego, expert voyage",
    ],
    excluded: ["Budget détaillé", "Recommandations restaurants & activités", "Conseiller voyage dédié"],
  },
  confort: {
    name: "Confort",
    price: 49,
    tabs: ["itineraire", "roadmap", "carte", "budget", "infos", "vols", "documents"],
    chatbot: false,
    popular: true,
    desc: "Le plus complet pour voyager sereinement",
    features: [
      "Itinéraire jour par jour, personnalisé",
      "Budget détaillé par poste de dépense",
      "Recommandations restaurants & activités",
      "Informations pratiques complètes",
      "Checklist documents et visa",
      "Liens de réservation pré-remplis",
      "Validation personnelle de Diego",
    ],
    excluded: ["Conseiller voyage dédié"],
  },
  serenite: {
    name: "Sérénité",
    price: 79,
    tabs: ["itineraire", "roadmap", "carte", "budget", "infos", "vols", "documents"],
    chatbot: true,
    desc: "L'accompagnement expert de bout en bout",
    features: [
      "Tout l'offre Confort inclus",
      "Validation approfondie et personnalisée par Diego",
      "Conseiller voyage dédié à votre destination",
      "Session questions/réponses avant le départ",
    ],
    excluded: [],
  },
};

// ── Booking helpers ─────────────────────────────────────────────────────────────
export const BOOKING_LINKS = (dest, from, dateD, dateR) => [
  { label: "Skyscanner", url: `https://www.skyscanner.fr/transport/vols/paris/${encodeURIComponent(dest)}/${dateD?.replace(/-/g, "")}/`, color: "#00A3E0" },
  { label: "Google Flights", url: `https://www.google.com/flights?hl=fr#flt=${from}.${dest}.${dateD}*${dest}.${from}.${dateR}`, color: "#4285F4" },
  { label: "Kayak", url: `https://www.kayak.fr/flights/PAR-${dest}/${dateD}/${dateR}`, color: "#FF690F" },
];

export const HOTEL_LINKS = (dest, dateD, dateR) => [
  { label: "Booking.com", url: `https://www.booking.com/searchresults.fr.html?ss=${encodeURIComponent(dest)}&checkin=${dateD}&checkout=${dateR}`, color: "#003580" },
  { label: "Airbnb", url: `https://www.airbnb.fr/s/${encodeURIComponent(dest)}/homes?checkin=${dateD}&checkout=${dateR}`, color: "#FF5A5F" },
];

export const ACTIVITY_LINKS = (dest) => [
  { label: "Viator", url: `https://www.viator.com/fr-FR/search?q=${encodeURIComponent(dest)}`, color: "#328F99" },
  { label: "GetYourGuide", url: `https://www.getyourguide.fr/s/?q=${encodeURIComponent(dest)}`, color: "#FF8000" },
];
